import { render, staticRenderFns } from "./CharField.vue?vue&type=template&id=f4d3c948&"
import script from "./CharField.vue?vue&type=script&lang=ts&"
export * from "./CharField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports